// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/public.less
// module id = 1677
// module chunks = 0